import { c } from '../../utils/tailwind-merge';
import { Badge } from '../Badge/Badge';

import { Button } from '../Button/Button';
import { PackageCompatibilityTable } from '../PackageCompatibilityTable/PackageCompatibilityTable';
import { PackageInfoTable } from '../PackageInfoTable/PackageInfoTable';
import { RichText } from '../RichText/RichText';
import { Separator } from '../Separator/Separator';
import { PackageDetailProps } from './types';

export const PackageDetail = ({
  name,
  isEntitled,
  description,
  info,
  compatibility,
  microcopy,
  className = '',
  onOpenInUnity,
}: PackageDetailProps) => {
  return (
    <article className={className}>
      {name && (
        <h2
          className={c(
            'body-small-medium mb-9 flex gap-2.5 md:mb-5',
            className
          )}
        >
          {name}
          <Badge text={microcopy.owned} className={c('block md:hidden')} />
        </h2>
      )}

      <div className={c('mb-9 hidden items-center gap-5 md:flex')}>
        <Button
          style={'secondary'}
          label={microcopy.openInUnity}
          onClick={onOpenInUnity}
          disabled={!isEntitled}
          edge="square"
          size="tiny"
          className={`tiny-text rounded-lg px-10 py-1
            ring-2 ring-inset ring-blue
            hover:ring-blue-hover
            disabled:ring-grey-200`}
        />
        {!isEntitled && (
          <p className={c('body-tiny text-grey-600')}>{microcopy.notOwned}</p>
        )}
      </div>
      <h3 className={c('tiny-text mb-4 font-medium')}>
        {microcopy.description}
      </h3>
      <RichText
        type="p"
        html={description}
        className={c('tiny-text mb-10 max-w-[812px] !text-grey-700')}
      />
      <div
        className={c(
          'mb-12 flex flex-col md:flex-row [&_div:first-child]:mb-12 md:[&_div:first-child]:mb-0'
        )}
      >
        <PackageInfoTable {...info} />
        <Separator
          orientation="vertical"
          className={c('ml-11 mr-6 hidden h-auto md:block')}
        />
        <PackageCompatibilityTable {...compatibility} />
      </div>
    </article>
  );
};
